( function () {
	function createConfig( slider ) {
		const section = slider.closest( '.wp-block-sweettyspace-categories, .wp-block-sweettyspace-featured-bakeries' );
		const prevButton = section?.querySelector( '.slider-prev' );
		const nextButton = section?.querySelector( '.slider-next' );
		const totalSlides = slider.querySelectorAll( '.swiper-slide' ).length;
		const loop = slider.dataset.loop !== 'false';
		const gap = parseInt( slider.dataset.gap || '16', 10 );
		const desktop = parseInt( slider.dataset.slidesDesktop || '4', 10 );
		const tablet = parseInt( slider.dataset.slidesTablet || '2', 10 );
		const mobile = parseInt( slider.dataset.slidesMobile || '1', 10 );

		return {
			loop: loop && totalSlides > 1,
			speed: 450,
			observer: true,
			observeParents: true,
			resistanceRatio: 0.85,
			threshold: 8,
			touchReleaseOnEdges: true,
			slidesPerView: mobile,
			spaceBetween: gap,
			navigation: prevButton && nextButton ? {
				prevEl: prevButton,
				nextEl: nextButton,
			} : undefined,
			breakpoints: {
				640: {
					slidesPerView: tablet,
					spaceBetween: gap,
				},
				960: {
					slidesPerView: desktop,
					spaceBetween: gap,
				},
			},
		};
	}

	function init() {
		if ( 'undefined' === typeof window.Swiper ) {
			return;
		}

		document
			.querySelectorAll( '.wp-block-sweettyspace-categories .swiper, .wp-block-sweettyspace-featured-bakeries .swiper' )
			.forEach( function ( slider ) {
				if ( slider.swiper ) {
					return;
				}

				const config = createConfig( slider );
				new window.Swiper( slider, config );
			} );
	}

	if ( document.readyState === 'loading' ) {
		document.addEventListener( 'DOMContentLoaded', init, { once: true } );
	} else {
		init();
	}
} )();
